export const sortByNameFn = (municipality1: any, municipality2: any) => {
    if (municipality1.namefin.localeCompare(municipality2.namefin) > 0) {
        return 1;
    }
    if (municipality1.namefin.localeCompare(municipality2.namefin) < 0) {
        return -1;
    }

    return 0;
};
